import request from '@/api/request'

export const holidayItineraryPage = (data) => {
    return request('/holidayItinerary/page', 'post', data)
}
export const holidayItinerarySave = (data) => {
    return request('/holidayItinerary/save', 'post', data)
}
export const holidayItineraryUpdate = (data) => {
    return request('/holidayItinerary/update', 'post', data)
}
export const holidayOrderPage = (data) => {
    return request('/orderHolidayItinerary/page', 'post', data)
}
export const holidayOrderUpdate = (data) => {
    return request('/orderHolidayItinerary/update', 'post', data)
}

export const sightsPage = (data) => {
    return request('/holidayItinerarySights/page', 'post', data)
}
export const sightsSave = (data) => {
    return request('/holidayItinerarySights/save', 'post', data)
}
export const sightsUpdate = (data) => {
    return request('/holidayItinerarySights/update', 'post', data)
}
export const restaurantPage = (data) => {
    return request('/holidayItineraryRestaurant/page', 'post', data)
}
export const restaurantSave = (data) => {
    return request('/holidayItineraryRestaurant/save', 'post', data)
}
export const restaurantUpdate = (data) => {
    return request('/holidayItineraryRestaurant/update', 'post', data)
}
/* 费用 */
export const itineraryCostPage = (data) => {
    return request('/order/holiday/itinerary/cost/page', 'post', data)
}
export const itineraryCostSave = (data) => {
    return request('/order/holiday/itinerary/cost/save', 'post', data)
}
export const itineraryCostUpdate = (data) => {
    return request('/order/holiday/itinerary/cost/update', 'post', data)
}
export const itineraryCostRemove = (data) => {
    return request('/order/holiday/itinerary/cost/remove', 'delete', data)
}
export const orderHolidayItineraryCost = (data) => {
  return request('orderHolidayItinerary/cost', 'post', data)
}
